<template>

    <div class="widget-content-product-list" v-if="category" :style="{ '--dmb-widget-content-product-list-image-size': resolvedImageSize }">

        <div class="category-title" v-if="widget.settings.showCategory">
            <dmb-widget-styled-text :style="widget.settings.categoryTextStyle">{{ category.title }}</dmb-widget-styled-text>
        </div>

        <table :style="{ '--dmb-widget-content-product-list-title-factor': titleFactor }">
            <tr v-if="
                widget.settings.showImage || 
                widget.settings.showTitle ||
                (widget.settings.showSubtitle && widget.settings.subtitlePosition === 'NEXT') ||
                (widget.settings.showPrice && widget.settings.showVariant)
            ">
                <th v-if="widget.settings.showImage"></th>
                <th v-if="widget.settings.showTitle"></th>
                <th v-if="widget.settings.showPrice && widget.settings.showVariant" v-for="variant in categoryVariants">
                    <dmb-widget-styled-text :style="widget.settings.variantTextStyle">{{ variant.title }}</dmb-widget-styled-text>
                </th>
            </tr>
            <tr v-for="product in products" :style="{ '--dmb-widget-content-product-list-row-padding': resolvedRowSpacing }">
                <td class="image" v-if="widget.settings.showImage">
                    <div class="product-image" v-if="widget.settings.showImage && getImageAsset(product)" v-background-image="getImageAsset(product).url"></div>
                </td>
                <td class="title" v-if="widget.settings.showTitle">

                    <div class="title-inner">
                        <dmb-widget-styled-text class="title-text" :style="widget.settings.titleTextStyle">{{ product.title }}</dmb-widget-styled-text>

                      <template v-if="widget.settings.showSubtitle && widget.settings.subtitlePosition === 'NEXT'">
                        <dmb-widget-styled-text class="subtitleText" v-for="(line, i) in subtitleLines(product)" :key="i"
                                                :style="widget.settings.subtitleTextStyle">
                          {{ line }}
                        </dmb-widget-styled-text>
                      </template>

                      <dmb-label-badges v-if="widget.settings.showLabels !== false && badgeLabels(product).length && widget.settings.labelPosition !== 'BELOW'"
                                        :labels="badgeLabels(product)" :text-style="widget.settings.labelTextStyle || widget.settings.subtitleTextStyle" :image-size="widget.settings.labelImageSize"></dmb-label-badges>
                    </div>

                    <template v-if="widget.settings.showSubtitle && widget.settings.subtitlePosition === 'BELOW'">
                      <dmb-widget-styled-text v-for="(line, i) in subtitleLines(product)" :key="i"
                                              :style="widget.settings.subtitleTextStyle">
                        {{ line }}
                      </dmb-widget-styled-text>
                    </template>

                    <dmb-label-badges v-if="widget.settings.showLabels !== false && badgeLabels(product).length && widget.settings.labelPosition === 'BELOW'"
                                      :labels="badgeLabels(product)" :text-style="widget.settings.labelTextStyle || widget.settings.subtitleTextStyle" :image-size="widget.settings.labelImageSize"></dmb-label-badges>

                </td>
                <td class="price" v-if="widget.settings.showPrice" v-for="variant in categoryVariants">
                    <dmb-widget-styled-text :style="widget.settings.priceTextStyle">
                        <dmb-price :currency="widget.settings.showCurrency" :mode="widget.settings.priceMode" :price="getProductPrice(variant, product)" />
                    </dmb-widget-styled-text>
                </td>
            </tr>
        </table>

    </div>
    <div v-else class="widget-content-placeholder">{{ $t('app.widgets.widgetContentProductList.noProducts') }}</div>

</template>

<script>

import { Vue, Options } from 'vue-class-component'
import { compact, sortBy, isNil } from 'lodash'

import Asset from "../ui/Asset.vue";
import WidgetStyledText from '../WidgetStyledText.vue';
import Price from '../Price.vue';

import ProductState from '../../enum/ProductState';
import LabelBadges from './LabelBadges.vue';
import {subtitleLines} from '../../util/labelDisplay';

export default Options({
    name: 'dmb-widget-content-product-list',
    components: {
        [WidgetStyledText.name]: WidgetStyledText,
        [Asset.name]: Asset,
        [Price.name]: Price,
        [LabelBadges.name]: LabelBadges,
    },
    props: {
        widget: Object,
        freeze: Boolean
    }
})(
    class WidgetContentProductList extends Vue {

        getProductPrice(variant, product){

            return product.prices.find(price => price.variantId === variant.id)?.price;
        }

        get category(){

            return this.$store.getters.getProductCategory(this.widget.settings.categoryId);
        }

        get categoryVariants(){

            return sortBy(this.category.variants, 'sortIndex');
        }

        subtitleLines(product){

            return subtitleLines(product);
        }

        badgeLabels(product){

            return product.labels || [];
        }


        get products(){

            if(this.category == null){
                return [];
            }

            let products = [];

            if(this.widget.settings.productIds?.length){
                products = compact(this.widget.settings.productIds.map(productId => this.$store.getters.getProduct(productId)));
            }
            else if(this.category) {
                 products = this.$store.state.products.products.filter(product => product.categoryId === this.category.id)
            }

            products = products.filter(product => product.state === ProductState.AVAILABLE);

            return sortBy(products, 'sortIndex');
        }

        get resolvedRowSpacing(){

            let spacing = !isNil(this.widget.settings.rowSpacing) ? this.widget.settings.rowSpacing : 10;
            return spacing + 'px';
        }

        get resolvedImageSize(){

            let size = !isNil(this.widget.settings.imageSize) ? this.widget.settings.imageSize : 50;
            return size + 'px';
        }

        get titleFactor(){

           return this.widget.settings.titleTextStyle?.size || 10;
        }

        get showStyle(){

            return this.$store.state.style.showStyle;
        }

        getImageAsset(product){

            return product.imageAssetId ? this.$store.getters.getAsset(product.imageAssetId) : null;
        }
    }
)

</script>
<style src="../../../scss/component/widget/WidgetContentProductList.scss" lang="scss"></style>
